export const getValidMail = (allowEmpty) => (mail) => {
  if (!mail && !allowEmpty) {
    return false;
  } else if (!mail && allowEmpty) {
    return true;
  }
  const regEx = /^[\wæøåÆØÅ-]+(\.[\wæøåÆØÅ-]+)*@([\w-]+\.)+[\w-]{2,}$/;
  return mail.match(regEx) || '';
};

export const getValidLink = (allowEmpty) => (link) => {
  if (!link && !allowEmpty) {
    return false;
  } else if (!link && allowEmpty) {
    return true;
  }

  // eslint-disable-next-line no-useless-escape
  const regEx = /^https?:\/\/[\w\-]+(\.[\w\-]+)+[/#?]?.*$/;
  return link.match(regEx) || '';
};

/**
 * Creates a validator function that returns true if one of the validators accepts the input
 * @param {boolean} allowEmpty if the validators should evluate empty values to true
 * @param {(function)[]} validators the validators to use
 */
export const checkMultipleValidators = (allowEmpty, validators) => (value) => {
  var isValid = false;
  validators &&
    Array.isArray(validators) &&
    validators.forEach((validator) => {
      if (validator(allowEmpty)(value)) {
        isValid = true;
      }
    });
  return isValid;
};

export const validPhoneNumber = (allowEmpty) => (phoneNumber) => {
  if (!phoneNumber && !allowEmpty) {
    return false;
  } else if (!phoneNumber && allowEmpty) {
    return true;
  }
  const regEx = /^\(\+45\) \d{4}-\d{4}$/;
  return phoneNumber.match(regEx) || '';
};

export const getPhoneNumber = (phoneNumber) => {
  return validPhoneNumber(phoneNumber)
    ? phoneNumber.replace('(+45) ', '').replace('-', '')
    : '';
};

/**
 * Helps ensuring correct format on phonenumbers. Allows to manually write everything,
 * but also allows to just type 8 digits, and still getting the correct format
 * @param {*} value input from field
 * @returns phone number in the format (+##) ####-####
 */
export const formatPhoneNumber = (value) => {
  if (!value) return '';

  let stripped = value.trimStart();

  if (stripped.startsWith('(+45)')) {
    stripped = stripped.slice(5);
    if (stripped.replace(/[^\d]/g, '').length === 0) return '(+45)';
  } else if (stripped.startsWith('+45')) {
    stripped = stripped.slice(3);
  } else if (stripped.startsWith('(+') || stripped.startsWith('(')) {
    return value;
  }

  const digits = stripped.replace(/[^\d]/g, '').slice(0, 8);

  const trimmed = stripped.trimStart();
  if (digits.length === 4 && trimmed.endsWith('-')) {
    return `(+45) ${digits}-`;
  }

  if (digits.length === 0) return '';
  if (digits.length <= 4) return `(+45) ${digits}`;
  return `(+45) ${digits.slice(0, 4)}-${digits.slice(4)}`;
};
